import { render, staticRenderFns } from "./ChangeLabel.vue?vue&type=template&id=3605972f&scoped=true&"
import script from "./ChangeLabel.vue?vue&type=script&lang=js&"
export * from "./ChangeLabel.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLabel.vue?vue&type=style&index=0&id=3605972f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3605972f",
  null
  
)

export default component.exports